module.exports = __webpack_public_path__ + "img/login-img.132a4038.png";